<template>
  <loader-wrapper>
    <el-badge>
      <div
        :class="[
          'check-list-flags__flag is-act',
          { active: true },
          response['act-status'],
        ]"
      >
        АКТ
      </div>
    </el-badge>
  </loader-wrapper>
</template>

<script>
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'ActStatus',
  components: {
    LoaderWrapper,
  },
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    act: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
<style lang="sass" scoped>
.check-list-flags__flag.is-act.danger
  color: #f00
.check-list-flags__flag.is-act.warning
   color: #ffb800
.check-list-flags__flag.is-act.success
   color: #00bf40
.act-badge
  &:after
    content: ''
    position: absolute
    background: url('~@/assets/img/sign-badge.png')
    width: 13px
    height: 15px
    top: -9px
    right: -9px
    background-size: cover
</style>
